import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Image from "react-bootstrap/Image";
import Offcanvas from "react-bootstrap/Offcanvas";
import Button from "react-bootstrap/Button";
import Accordion from "react-bootstrap/Accordion";
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // Import icons
import Logo from "../../assets/images/black-logo.png";
import SrkayLogo from "../../assets/images/brands/srkay-logo.png";
import { CiMenuFries } from "react-icons/ci";

const Header = () => {
  const [show, setShow] = useState(false);
  const [solutionsOpen, setSolutionsOpen] = useState(false); // State for Solutions dropdown
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const [companyOpen, setCompanyOpen] = useState(false);
  const location = useLocation(); // Hook to get the current location

  // Open desktop nav dropdowns on hover (click still works via onToggle)
  const hoverToggle = (setOpen) => ({
    onMouseEnter: () => window.innerWidth >= 992 && setOpen(true),
    onMouseLeave: () => window.innerWidth >= 992 && setOpen(false),
  });

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [isSubmitted, setIsSubmitted] = useState(false);

  const [, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    // Scroll to top whenever the location changes
    window.scrollTo(0, 0);

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location]);


  const [, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
    setIsSubmitted(false); // Reset the state when the modal closes
    setResponseMessage(""); // Also good practice to clear any messages
    setLoading(false); // Reset loading state
  };

  /*contact form*/

  const [, setLoading] = useState(false);
  const [, setResponseMessage] = useState("");


  // Handle input changes

  useEffect(() => {
    if (isSubmitted) {
      const timer = setTimeout(() => {
        handleCloseModal();
      }, 60000);

      // Cleanup function to clear the timer if the component unmounts
      // or the state changes before the timer finishes
      return () => clearTimeout(timer);
    }
  }, [isSubmitted]); // The effect runs whenever isSubmitted changes

  // Handle form submission

  return (
    <>
      {/* Main Navbar */}
      <style>
        {`.top-fixed {
          position: sticky;
          top: 0;
          width: 100%;
          z-index: 2;
          transform: translate3d(0, 0, 0);
  animation-name: fade-in-down;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  transition: all 0.4s;
        }
//           .sticky-top {
//           top:42px;
// }
/* Define the keyframes for the zooming effect */
@keyframes zoom-pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05); /* Zooms the text in slightly */
  }
  100% {
    transform: scale(1); /* Zooms the text back out */
  }
}

/* Apply the animation to the new class */
.zoom-animate {
  animation: zoom-pulse 2s ease-in-out infinite; /* 2s duration, ease-in-out timing, infinite loop */
}

.marquee-container {
  /* This creates a fixed-width container that hides the overflowing content. */
  width: 100%;
  overflow: hidden;
}

.marquee-content {
  gap: 60px;
  animation: marquee 20s linear infinite;
}

// @keyframes marquee {
//   0% {
//     transform: translateX(100%);
//   }
//   100% {
//     transform: translateX(-100%);
//   }
// }

.marquee-container:hover .marquee-content {
  animation-play-state: paused;
}

        `}
      </style>

      {/* <div
        className={`marquee-container ${scrolled ? "top-fixed" : ""}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          width: "100%",
          textAlign: "center",
          backgroundColor: "#056298",
          color: "white",
          padding: "10px 5px",
          fontSize: "1rem",
          fontWeight: "bold",
        }}
      >
        <div>
          <div
            className="marquee-content d-sm-flex justify-content-center"
            style={{
              animationPlayState: isHovered ? "paused" : "running",
            }}
          >
            <p
              className="text-white text-sm align-items-center justify-content-center mb-0"
              style={{
                margin: 0,
                fontSize: "15px",
                display: "inline-block",
                whiteSpace: "normal",
              }}
            >
              We're Exhibiting at GITEX 2025.{" "}
              <a
                href="gitexdubai2025"
                className="font-semibold ms-1 zoom-animate"
                style={{
                  fontWeight: "700",
                  textDecoration: "underline",
                  color: "white",
                }}
              >
                Book your meeting Now !
              </a>
            </p>
            <p
              className="text-white text-sm align-items-center justify-content-center mb-0"
              style={{
                margin: 0,
                fontSize: "15px",
                display: "inline-block",
                whiteSpace: "normal",
              }}
            >
              We’re at Dreamforce 2025.
              <a
                onClick={handleOpenModal}
                className="font-semibold ms-1 zoom-animate"
                style={{
                  fontWeight: "700",
                  textDecoration: "underline",
                  color: "white",
                  cursor: "pointer",
                }}
              >
                Book your meeting Now !
              </a>
            </p>
          </div>
        </div>

        <Modal
          show={showModal}
          size="xl"
          onHide={handleCloseModal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          style={{ overflow: "hidden" }}
        >
          <style>
            {`.btn-close {
          position: absolute;
          top: 1rem;
          right: 1rem;
          z-index: 2;
        }
        .modal-content{overflow:hidden !important;}
        
        `}
          </style>
          <Modal.Header className="p-0" closeButton></Modal.Header>
          <Modal.Body className="p-0">
            <div className="bg-E2F1FE position-relative box-shadow-one rounded-4 pt-5 p-23 p-sm-23">
              <Image
                src={LayerFour}
                className="position-absolute bottom-0 start-0 w-40"
              />

              <Row className="position-relative form-box z-0">
                {isSubmitted ? null : (
                  <Col lg={5}>
                    <div class="text-left d-flex  justify-content-start">
                      <h2 class="section-heading fw-700 fs-2">
                        Book Your Meeting With{" "}
                        <span className="text-ee0000">
                          Comsense Technologies
                        </span>
                        <span className="bordered-text bordered-text-start">
                          @ Dreamforce 2025
                        </span>
                      </h2>
                    </div>
                  </Col>
                )}
                <Col lg={isSubmitted ? 12 : 7}>
                  {isSubmitted ? (
                    <div className="text-center mt-5 mb-5">
                      <div class="text-center d-flex  justify-content-start">
                        <h2 class="section-heading m-auto fw-700 fs-2">
                          <span className="bordered-text bordered-text-start">
                            Thank You !
                          </span>
                        </h2>
                      </div>
                      <p className="fs-4 fw-700 mt-4">
                        Our co-founders — Sagar Babar, Sushil Gujrathi & Biju
                        Nambiar — will be at Dreamforce 2025.
                      </p>
                    </div>
                  ) : (
                    <Form onSubmit={handleSubmit}>
                      <Row className="pb-3 mt-3 mt-lg-0">
                        <Col lg={6}>
                          <>
                            <Form.Label htmlFor="inputPassword5">
                              Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                            />
                          </>
                        </Col>
                        <Col lg={6}>
                          <>
                            <Form.Label>Business Email Address</Form.Label>
                            <Form.Control
                              type="email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                            />
                          </>
                        </Col>
                        <Col lg={6}>
                          <>
                            <Form.Label htmlFor="CompanyName">
                              Company Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="company"
                              value={formData.company}
                              onChange={handleChange}
                            />
                          </>
                        </Col>
                        <Col lg={12}>
                          <>
                            <Form.Label htmlFor="Message">Message</Form.Label>
                            <Form.Control
                              name="message"
                              value={formData.message}
                              onChange={handleChange}
                              as="textarea"
                              rows={4}
                            />
                          </>
                        </Col>
                        <Col lg={12} className="mt-4 text-start">
                          <>
                            <Button
                              variant=""
                              type="submit"
                              className="fw-600 d-block btn btn-danger btn-xl"
                              disabled={loading}
                            >
                              {loading ? "Booking Now..." : "Book Now"}
                            </Button>
                          </>
                        </Col>
                        {responseMessage && (
                          <p
                            className="mt-3 mb-0 fs-12 text-center"
                            style={{ color: loading ? "blue" : "red" }}
                          >
                            {responseMessage}
                          </p>
                        )}
                      </Row>
                    </Form>
                  )}
                </Col>
              </Row>
            </div>
          </Modal.Body>
        </Modal>
      </div> */}
      <Navbar collapseOnSelect expand="lg" sticky="top">
        <Container>
          <Navbar.Brand href="/" className="d-flex align-items-center">
            <Image width={150} src={Logo} />
            {location.pathname === "/global-capability-center/GCC" && (
              <>
                <div
                  className="mx-2"
                  style={{
                    height: "30px",
                    borderLeft: "1px solid #ccc",
                  }}
                ></div>
                <Image width={100} src={SrkayLogo} />
              </>
            )}
          </Navbar.Brand>
          {/* Mobile Offcanvas Toggle Button */}
          <div className="d-lg-none">
            <Button variant="light" onClick={handleShow}>
              <CiMenuFries />
            </Button>
          </div>
          {/* Desktop Menu */}
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto"></Nav>
            <Nav>
              <Nav.Link as={Link} to="/" active={location.pathname === "/"}>
                Home
              </Nav.Link>
              {/* <NavDropdown
                title={
                  <>
                    Services{' '}
                    {servicesOpen ? (
                      <FaChevronUp className="dropdown-icon" />
                    ) : (
                      <FaChevronDown className="dropdown-icon" />
                    )}
                  </>
                }
                id="collapsible-nav-dropdown"
                className={`nav-dropdown-menu ${[
                    "/strategyAndConsulting",
                    "/implementation",
                    "/customIntegrations",
                    "/designAndArchitecture",
                    "/data"
                  ].includes(location.pathname) ? "active" : ""
                  }`}
                onToggle={(isOpen) => setServicesOpen(isOpen)} // Update state on toggle
              >
                <NavDropdown.Item
                  as={Link} to="/strategyAndConsulting"
                  active={location.pathname === "/strategyAndConsulting"}
                >
                  Strategy & Consulting
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link} to="/implementation"
                  active={location.pathname === "/implementation"}
                >
                  Implementation
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link} to="/customIntegrations"
                  active={location.pathname === "/customIntegrations"}
                >
                  Custom Integrations
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link} to="/designAndArchitecture"
                  active={location.pathname === "/designAndArchitecture"}
                >
                  Design & Architecture
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link} to="/data"
                  active={location.pathname === "/data"}
                >
                  Data
                </NavDropdown.Item>
              </NavDropdown> */}

              <NavDropdown
                title={
                  <>
                    Salesforce{" "}
                    {solutionsOpen ? (
                      <FaChevronUp className="dropdown-icon" />
                    ) : (
                      <FaChevronDown className="dropdown-icon" />
                    )}
                  </>
                }
                id="collapsible-nav-dropdown"
                className={`nav-dropdown-menu ${[
                  "/data-cloud",
                  "/marketing-cloud",
                  "/service-cloud",
                  "/loyalty-management",
                  "/tableau",
                  "/marketing-cloud-personalization",
                  "/agent-force",
                ].includes(location.pathname)
                  ? "active"
                  : ""
                  }`}
                show={solutionsOpen}
                onToggle={(isOpen) => setSolutionsOpen(isOpen)} // Update state on toggle
                {...hoverToggle(setSolutionsOpen)}
              >
                <NavDropdown.Item
                  as={Link}
                  to="/data-cloud"
                  active={location.pathname === "/data-cloud"}
                >
                  Salesforce Data Cloud
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/marketing-cloud"
                  active={location.pathname === "/marketing-cloud"}
                >
                  Salesforce Marketing Cloud
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/service-cloud"
                  active={location.pathname === "/service-cloud"}
                >
                  Salesforce Sales & Service Cloud
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/loyalty-management"
                  active={location.pathname === "/loyalty-management"}
                >
                  Salesforce Loyalty Management
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/tableau"
                  active={location.pathname === "/tableau"}
                >
                  Salesforce Tableau
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/marketing-cloud-personalization"
                  active={
                    location.pathname === "/marketing-cloud-personalization"
                  }
                >
                  Salesforce Marketing Personalization
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/agent-force"
                  active={location.pathname === "/agent-force"}
                >
                  Salesforce Agentforce
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/slack"
                  active={location.pathname === "/slack"}
                >
                  Salesforce Slack
                </NavDropdown.Item>
                {/* <NavDropdown.Item
                  as={Link}
                  to="/AI-Lab-ODC"
                  active={location.pathname === "/AILabODC"}
                >
                  AI Lab - Offshore Delivery Center
                </NavDropdown.Item> */}
              </NavDropdown>
              <NavDropdown
                title={
                  <>
                    Products{" "}
                    {productsOpen ? (
                      <FaChevronUp className="dropdown-icon" />
                    ) : (
                      <FaChevronDown className="dropdown-icon" />
                    )}
                  </>
                }
                id="products-dropdown"
                className="nav-dropdown-menu"
                show={productsOpen}
                onToggle={(isOpen) => setProductsOpen(isOpen)}
                {...hoverToggle(setProductsOpen)}
              >
                <NavDropdown.Item
                  href="https://aicopilot.comsensetechnologies.com/"
                  target="_blank"
                >
                  AI Copilot
                </NavDropdown.Item>


                {/* <NavDropdown.Item href="https://fusion360.ai/" target="_blank">
                  Fusion360
                </NavDropdown.Item> */}

                <NavDropdown.Item
                  href="https://thinkcraft.comsensetechnologies.com/"
                  target="_blank"
                >
                  ThinkCraft
                </NavDropdown.Item>

                {/* <NavDropdown.Item href="https://happydemo.io/" target="_blank">
                  Happy Demo
                </NavDropdown.Item> */}

                <NavDropdown.Item
                  href="https://app.trym.ly/#home"
                  target="_blank"
                >
                  LynkSense
                </NavDropdown.Item>

                <NavDropdown.Item
                  href="https://www.kleanmail.com/"
                  target="_blank"
                >
                  Kleanmail
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/riya-ai-voice-agent"
                  active={location.pathname === "/riya-ai-voice-agent"}
                >
                  Riya AI Voice Agent
                </NavDropdown.Item>

              </NavDropdown>
              {/* Engineering top-level menu */}
              <Nav.Link
                as={Link}
                to="/engineering"
                active={location.pathname === "/engineering"}
              >
                Engineering
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/global-capability-center/GCC"
                active={location.pathname === "/global-capability-center/GCC"}
              >
                GCC
              </Nav.Link>

              {/* 🔹 Resources Dropdown */}
              <NavDropdown
                title={
                  <>
                    Resources{" "}
                    {resourcesOpen ? (
                      <FaChevronUp className="dropdown-icon" />
                    ) : (
                      <FaChevronDown className="dropdown-icon" />
                    )}
                  </>
                }
                id="resources-dropdown"
                className={`nav-dropdown-menu ${["/blog", "/newsletter"].includes(location.pathname)
                  ? "active"
                  : ""
                  }`}
                show={resourcesOpen}
                onToggle={(isOpen) => setResourcesOpen(isOpen)}
                {...hoverToggle(setResourcesOpen)}
              >
                <NavDropdown.Item
                  as={Link}
                  to="/success-stories"
                  active={location.pathname.startsWith("/success-stories")}
                >
                  Success Stories
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/ebooks"
                  active={location.pathname.startsWith("/ebooks")}
                >
                  E-books
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/white-papers"
                  active={location.pathname.startsWith("/white-papers")}
                >
                  White Papers
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/press-releases"
                  active={location.pathname.startsWith("/press-releases")}
                >
                  Press Releases
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/blog"
                  active={location.pathname === "/blog"}
                >
                  Blogs
                </NavDropdown.Item>

                <NavDropdown.Item
                  as={Link}
                  to="/newsletter"
                  active={location.pathname === "/newsletter"}
                >
                  Newsletter
                </NavDropdown.Item>
              </NavDropdown>
              <NavDropdown
                title={
                  <>
                    Company{" "}
                    {companyOpen ? (
                      <FaChevronUp className="dropdown-icon" />
                    ) : (
                      <FaChevronDown className="dropdown-icon" />
                    )}
                  </>
                }
                id="company-dropdown"
                className={`nav-dropdown-menu ${["/about", "/careers", "/contact"].includes(location.pathname)
                  ? "active"
                  : ""
                  }`}
                show={companyOpen}
                onToggle={(isOpen) => setCompanyOpen(isOpen)}
                {...hoverToggle(setCompanyOpen)}
              >
                <NavDropdown.Item
                  as={Link}
                  to="/about"
                  active={location.pathname === "/about"}
                >
                  About Us
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/careers"
                  active={location.pathname === "/careers"}
                >
                  Careers
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/contact"
                  active={location.pathname === "/contact"}
                >
                  Contact Us
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Mobile Offcanvas */}
      <Offcanvas show={show} onHide={handleClose} className="d-lg-none">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">
            <Nav.Link as={Link} to="/" active={location.pathname === "/"}>
              Home
            </Nav.Link>
            {/* Accordion for Mobile Dropdowns */}
            <Accordion flush>
              <Accordion.Item eventKey="0">
                <Accordion.Header>Salesforce</Accordion.Header>
                <Accordion.Body>
                  <Nav.Link
                    as={Link}
                    to="/data-cloud"
                    active={location.pathname === "/data-cloud"}
                  >
                    Salesforce Data Cloud
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/marketing-cloud"
                    active={location.pathname === "/marketing-cloud"}
                  >
                    Salesforce Marketing Cloud
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/service-cloud"
                    active={location.pathname === "/service-cloud"}
                  >
                    Salesforce Sales & Service Cloud
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/loyalty-management"
                    active={location.pathname === "/loyalty-management"}
                  >
                    Salesforce Loyalty Management
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/tableau"
                    active={location.pathname === "/tableau"}
                  >
                    Salesforce Tableau
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/marketing-cloud-personalization"
                    active={
                      location.pathname === "/marketing-cloud-personalization"
                    }
                  >
                    Salesforce Marketing Cloud Personalization
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/agent-force"
                    active={location.pathname === "/agent-force"}
                  >
                    Salesforce Agentforce
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/slack"
                    active={location.pathname === "/slack"}
                  >
                    Salesforce Slack
                  </Nav.Link>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <Accordion flush>
              <Accordion.Item eventKey="1">
                <Accordion.Header>Products</Accordion.Header>
                <Accordion.Body>
                  <Nav.Link
                    href="https://aicopilot.comsensetechnologies.com/"
                    target="_blank"
                  >
                    AI Copilot
                  </Nav.Link>


                  {/* <Nav.Link href="https://fusion360.ai/" target="_blank">
                    Fusion360
                  </Nav.Link> */}

                  <Nav.Link
                    href="https://thinkcraft.comsensetechnologies.com/"
                    target="_blank"
                  >
                    ThinkCraft
                  </Nav.Link>

                  {/* <Nav.Link href="https://happydemo.io/" target="_blank">
                    Happy Demo
                  </Nav.Link> */}

                  <Nav.Link href="https://app.trym.ly/#home" target="_blank">
                    LynkSense
                  </Nav.Link>

                  <Nav.Link href="https://www.kleanmail.com/" target="_blank">
                    Kleanmail
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/riya-ai-voice-agent"
                    active={location.pathname === "/riya-ai-voice-agent"}
                  >
                    Riya AI Voice Agent
                  </Nav.Link>

                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <Nav.Link
              as={Link}
              to="/engineering"
              active={location.pathname === "/engineering"}
            >
              Engineering
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/global-capability-center/GCC"
              active={location.pathname === "/global-capability-center/GCC"}
            >
              GCC
            </Nav.Link>

            {/* <Nav.Link
              as={Link}
              to="/blog"
              active={location.pathname === "/blog"}
            >
              Blog
            </Nav.Link> */}
            {/* Accordion for Mobile Dropdowns */}
            <Accordion flush>
              <Accordion.Item eventKey="2">
                <Accordion.Header>Resources</Accordion.Header>
                <Accordion.Body>
                  <Nav.Link
                    as={Link}
                    to="/success-stories"
                    active={location.pathname === "/success-stories"}
                  >
                    Success Stories
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/ebooks"
                    active={location.pathname === "/ebooks"}
                  >
                    E-books
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/white-papers"
                    active={location.pathname === "/white-papers"}
                  >
                    White Papers
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/press-releases"
                    active={location.pathname === "/press-releases"}
                  >
                    Press Releases
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/blog"
                    active={location.pathname === "/data-cloud"}
                  >
                    Blogs
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/newsletter"
                    active={location.pathname === "/marketing-cloud"}
                  >
                    Newsletter
                  </Nav.Link>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <Accordion flush>
              <Accordion.Item eventKey="3">
                <Accordion.Header>Company</Accordion.Header>
                <Accordion.Body>
                  <Nav.Link
                    as={Link}
                    to="/about"
                    active={location.pathname === "/about"}
                  >
                    About Us
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/careers"
                    active={location.pathname === "/careers"}
                  >
                    Careers
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/contact"
                    active={location.pathname === "/contact"}
                  >
                    Contact Us
                  </Nav.Link>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Header;
